$(document).ready(function(){
  console.log('ATC Popup Scripts Loaded');

  $('.atc-close').on('click', function(){
    $('.atc-popup').addClass('hidden');
  });

  $('#add-to-cart').on('click', function(){
    $('.atc-popup').addClass('hidden');
    $('.confirm-check').prop('checked', false);
  });
  
  $('.popup-trigger').on('click', function(){
    console.log('Popup Click Triggered');
    $('.atc-popup').removeClass('hidden');
  });

  $('.confirm-check').on('click', function() {
    if ($(this).is(':checked')) {
        console.log('checked');
        $('.atc-disable').removeClass('disabled');
    } else {
        $('.atc-disable').addClass('disabled');
        console.log('NOT checked');
    }
  });

});